<template>
  <Splide class="pb-[24px] laptop:pb-0" :has-track="false" :options="options" :aria-label="$t('our-newest-products')">
    <SplideTrack class="py-8">
      <SplideSlide class="flex justify-center" v-for="brand in data?.productBrands?.data" :key="brand.attributes?.slug">
        <BrandsBrandItem
          :selected="props.selectedBrand?.attributes?.name === brand.attributes?.name"
          :key="brand.attributes?.slug"
          :brand="brand"
          @selected="(selectedBrand) => emit('selected', selectedBrand)"
        />
      </SplideSlide>
    </SplideTrack>
    <div class="splide__arrows">
      <button class="splide__arrow--prev splide-arrow absolute !-left-[5em] top-[25%]">
        <svg width="80" height="23" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
        </svg>
      </button>
      <button class="splide__arrow--next splide-arrow absolute !-right-[5em] top-[25%]">
        <svg width="80" height="23" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
        </svg>
      </button>
    </div>
  </Splide>
</template>
<script setup lang="ts">
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";
import { theme } from "#tailwind-config";
import { BrandWithProductsFragment } from "#gql";

import { BrandsKey } from "~/symbols/symbols";

const data = inject(BrandsKey);

const laptop = theme?.screens?.laptop;
const tablet = theme?.screens?.tablet;

const laptopInt = parseInt(laptop.slice(0, -2));
const tabletInt = parseInt(tablet.slice(0, -2));

const options = {
  perPage: 5,
  pagination: false,
  gap: "1rem",
  arrows: true,
  breakpoints: {
    [laptopInt]: { perPage: 3, arrows: false, pagination: true, padding: "5rem", gap: "0.5rem" },
    [tabletInt]: { perPage: 1, pagination: true, padding: "20%", gap: 0 },
  },
};
const { t: $t } = useI18n();

const props = defineProps<{
  selectedBrand: BrandWithProductsFragment | null | undefined;
}>();

const emit = defineEmits<{
  (e: "selected", brand: BrandWithProductsFragment | null | undefined): void;
}>();
</script>

<style lang="scss" scoped>
:deep(.splide__pagination) {
  display: flex !important;
}
:deep(.splide-arrow) {
  transition: opacity 0.3s ease-out;
}

:deep(.splide__pagination__page) {
  background-color: #dfe1dd;
}
:deep(.splide__pagination__page.is-active) {
  background-color: #303030;
  transform: scale(1);
}
:deep(.splide-arrow) {
  &:disabled {
    opacity: 0;
  }
}
</style>
